import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { actions as cartActions, selectors as cartSelectors } from '@elab/core/store/cart';
import { selectors as configSelectors } from '@elab/core/store/config';
import { mask } from '@elab/core/utils/inputMaskHelpers';
import { selectors as uiSelectors } from '@elab/core/store/ui';

export class cartPhoneNumber extends LightLitElement {
    static get properties() {
        return {
            phoneNumber: { type: String },
            isOpened: { type: Boolean },
            cartData: { type: Object },

            active: { type: Boolean, reflect: true },
            focused: { type: Boolean, reflect: true },
            error: { type: Boolean, reflect: true },

            errorMessage: { type: String },
            errorMessageValidation: { type: String, attribute: 'error-message-validation' },
            errorMessageEmpty: { type: String, attribute: 'error-message-empty' },

            loaded: { type: Boolean },
            changed: { type: Boolean },

            maskConfig: { type: Object },
        };
    }

    constructor() {
        super();
        this.phoneNumber = '';
        this.errorMessage = '';
        this.changed = false;
        this.loaded = false;
        this.maskConfig = {};
    }

    updated(changedProperties) {
        if (changedProperties.has('cartData')) {
            this.loadFromCart();
        }
        if (changedProperties.has('isOpened')) {
            this.loadDialogData();
        }
    }

    async formatPhoneNumber(value) {
        const maskValue = this.maskConfig.common.mobileNumber.rules[0].config.mask;
        return await mask(value, { mask: maskValue });
    }

    async loadDialogData() {
        this.error = '';
        this.phoneNumber =
            (await this.formatPhoneNumber(this.cartData.phoneNumber)) ||
            this.maskConfig.common.cartPhoneNumber.rules[0].config.defaultValue;
    }

    loadFromCart() {
        if (!this.changed && !this.loaded) {
            if (this.cartData.code) {
                this.phoneNumber =
                    this.cartData.phoneNumber ||
                    this.maskConfig.common.cartPhoneNumber.rules[0].config.defaultValue;
                this.handleInput({ target: { value: this.phoneNumber } }, false);
            }
        }
        if (this.isOpened) this.active = true;
    }

    async handleInput(e, checkError = true) {
        let { value } = e.target;
        this.phoneNumber = e.target.value = await this.formatPhoneNumber(value);
        let phoneNumber = this.phoneNumber.replace(/\W/g, '');
        this.changed = true;
        this.toggleActive();
        this.dispatchEvent(
            new CustomEvent('set-cart-phone-number', {
                detail: phoneNumber,
            }),
        );
        this.errorCheck(checkError);
    }

    handleFocus() {
        this.focused = true;
        this.toggleActive();
    }

    handleBlur() {
        this.focused = false;
        this.toggleActive();
        this.errorCheck();
    }

    toggleActive() {
        this.active = !!this.phoneNumber || this.focused;
    }

    async errorCheck(checkError) {
        if (checkError) {
            this.error = this.checkInValidNumber();
            this.errorMessage = this.checkEmpty()
                ? this.errorMessageEmpty
                : this.errorMessageValidation;
        }
        this.setValidationStatus();
    }

    checkEmpty() {
        return !this.phoneNumber.length;
    }

    checkMask() {
        // eslint-disable-next-line elab-rules/detect-non-literal-regexp
        const regEx = new RegExp(
            this.maskConfig.common.cartPhoneNumber.rules[0].config.replacer.pattern,
            'g',
        );
        return regEx.test(this.phoneNumber.replace(/\W/g, ''));
    }

    checkInValidNumber() {
        return !this.checkMask() || this.checkEmpty();
    }

    setValidationStatus() {
        const isNotValid = this.checkInValidNumber();
        this.dispatchEvent(
            new CustomEvent('set-cart-phone-number-is-not-valid', {
                detail: isNotValid,
            }),
        );
    }

    render() {
        return html`
            <div class="input-field input-field--phone ">
                <label class="input-field__wrapper">
                    <input
                        name="phone"
                        type="text"
                        class="input-field__input"
                        value="${this.phoneNumber}"
                        @input=${this.handleInput}
                        @focus=${this.handleFocus}
                        @blur=${this.handleBlur}
                    />
                    <div class="input-field__labels">
                        <div class="input-field__label">
                            <v-slot></v-slot>
                        </div>
                    </div>
                </label>
                <div class="input-field__error">
                    <span class="input-field__error-icon"></span>
                    <span class="input-error">${this.errorMessage}</span>
                </div>
            </div>
        `;
    }
}

const mapStateToProps = state => ({
    cartData: cartSelectors.getData(state),
    maskConfig: configSelectors.getInputMasksConfig(state),
    isOpened: uiSelectors.getDialogState(state, 'enter-phone-number'),
});

const mapDispatchToEvents = dispatch => ({
    'set-cart-phone-number': ({ detail }) =>
        dispatch(cartActions.setDataAttr('phoneNumber', detail)),
    'set-cart-phone-number-is-not-valid': ({ detail }) =>
        dispatch(cartActions.setDataAttr('phoneNumberIsNotValid', detail)),
});

export default () =>
    customElements.define(
        'e2-cart-phone-number',
        connect(mapStateToProps, mapDispatchToEvents)(cartPhoneNumber),
    );
